// Other OptiPrime products that render inside this shell rather than the OptiSigns
// portal itself: OptiDev (/app/optidev) and OptiSound (/app/optisound). Same
// product family, sharing identity through OptiPrime IDM — just not this app.
//
// The Get Started checklist is OptiSigns-portal onboarding ("pair a screen",
// "create content"), so it has nothing to say on these pages and is HIDDEN while
// the user is in one. Hidden, not dismissed — this only skips rendering:
//   - the expanded/collapsed choice lives in localStorage (get-started-widget-store)
//   - "dismissed for good" lives on the server (company.getStarted.completed)
// so returning to any OptiSigns page brings the widget back exactly as it was.
export const OTHER_OPTIPRIME_PRODUCT_PREFIXES = ['/app/optidev', '/app/optisound'];

/**
 * Pure route-prefix check — pulled out of AppShell (scio3!2873) so it's testable
 * without mounting the shell. Same `startsWith` mechanism `isFullWidthPage` uses
 * inline in AppShell: a plain pathname prefix match, no host/store lookup.
 */
export function isOtherOptiPrimeProductPath(pathname: string): boolean {
  return OTHER_OPTIPRIME_PRODUCT_PREFIXES.some((p) => pathname.startsWith(p));
}

// Full-bleed editor surfaces where the floating checklist (bottom-right, z-40)
// sits on top of the canvas and the editor's own controls: the Designer (Canvas)
// at /app/designManagement. That includes Engage's design editor, which is the
// same route with `?engage=1`. Hidden, not dismissed — same contract as the
// OptiPrime prefixes above. List pages keep the checklist on purpose: the
// Engage list (/app/engageManagement) and the Templates gallery (/app/templateManagement).
export const CHECKLIST_HIDDEN_EDITOR_PREFIXES = ['/app/designManagement'];

/**
 * Should AppShell skip rendering the Get Started checklist on this route?
 * True on other OptiPrime products and on the full-bleed editor surfaces.
 */
export function isChecklistHiddenPath(pathname: string): boolean {
  return (
    isOtherOptiPrimeProductPath(pathname) ||
    CHECKLIST_HIDDEN_EDITOR_PREFIXES.some((p) => pathname.startsWith(p))
  );
}
